module.exports = __webpack_public_path__ + "img/equilibre.71a6cf01.svg";